import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { MeshGradient } from '../types/gradients';
import { DownloadButton } from './DownloadButton';
import { GlassmorphicContainer } from './GlassmorphicContainer';

interface GradientPreviewProps {
  gradient: MeshGradient;
}

export function GradientPreview({ gradient }: GradientPreviewProps) {
  const { isDarkMode } = useTheme();

  const gradientStyle = {
    background: `linear-gradient(${gradient.angle}deg, ${gradient.colors.join(', ')})`,
  };

  return (
    <div className="space-y-6">
      <GlassmorphicContainer>
        <div 
          className={`w-full aspect-square rounded-2xl relative overflow-hidden ${
            isDarkMode ? 'bg-[#252525]/40' : 'bg-white/40'
          }`}
        >
          <div className="w-full h-full" style={gradientStyle}>
            <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-white/10" />
          </div>
          
          <div className="absolute top-4 right-4">
            <DownloadButton gradient={gradient} />
          </div>
        </div>
      </GlassmorphicContainer>
    </div>
  );
}